module.exports = __webpack_public_path__ + "img/Weapon_195.2c7a4527.png";